import { useTranslation } from 'react-i18next';
import { Portal } from '../Portal';
import { useState } from 'react';

type Props = {
    src: string;
    srcThumbnail?: string;
    alt?: string;
};

export function ImageLightbox(props: Props) {
    const { t } = useTranslation();
    const [shouldShowModal, setShouldShowModal] = useState(false);
    const imgAlt = props.alt ?? '';

    const toggleModal = () => {
        setShouldShowModal((value) => !value);
    };

    return (
        <>
            <button
                onClick={toggleModal}
                className="cursor-pointer tooltip tooltip-right"
                data-tip={t('clickToZoom')}
            >
                <img
                    className="block border shadow-xl w-full"
                    src={props.srcThumbnail ?? props.src}
                    alt={imgAlt}
                />
            </button>

            {shouldShowModal && (
                <Portal>
                    <div className="fixed inset-0 bg-black bg-opacity-20 isolate grid place-items-center pointer-events-none z-50">
                        <div
                            aria-hidden="true"
                            className="fixed inset-0 pointer-events-auto cursor-pointer"
                            onClick={toggleModal}
                        />

                        <div className="">
                            <img
                                className="block max-h-screen"
                                src={props.src}
                                alt=""
                            />
                        </div>
                    </div>
                </Portal>
            )}
        </>
    );
}
